let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jH76t")).then(() => parcelRequire('fgFft'));